import React, { useState } from "react";
import Treasure from"../../asstes/Treasure.jpg"
import {
  FaBook,
  FaFlask,
  FaCalculator,
  FaPaperPlane,
  FaRegFrown,
  FaRegMeh,
  FaRegSmile,
  FaRegGrin,
  FaRegTired,
} from "react-icons/fa";
import { PiChatsCircle, PiBookOpenTextBold } from "react-icons/pi";
import Navbar from "../../components/PSTVue/Navbar2";
import { useNavigate } from "react-router-dom";
// Mock data that would typically come from an API
const userData = {


  
  name: "Smith",
  totalXp: 750,
  currentLevel: 4,
  levelName: "Learning Champion",
  xpForNextLevel: 1000,
};

const classrooms = [
  { name: "PersonalAI", icon: <FaCalculator />, color: "bg-blue-500", href: "/dashboard/student/personalai" },
  { name: "PlanningAI", icon: <FaFlask />, color: "bg-green-500", href: "/dashboard/student/planningai" },
  { name: "ClassroomAI", icon: <FaBook />, color: "bg-purple-500", href: "/dashboard/student/classroomai" },
];

const moodOptions = [
  { label: "Great", icon: <FaRegGrin size={24} /> },
  { label: "Good", icon: <FaRegSmile size={24} /> },
  { label: "Okay", icon: <FaRegMeh size={24} /> },
  { label: "Struggling", icon: <FaRegFrown size={24} /> },
  { label: "Need Help", icon: <FaRegTired size={24} /> },
];

// Reusable Card component
const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-xl shadow-sm p-4 sm:p-6 ${className}`}>
    {children}
  </div>
);

// Header Component
const Header = ({ name }) => (
  <div className="bg-blue-800 text-white p-6 rounded-xl shadow-lg">
    <h1 className="text-2xl sm:text-3xl font-bold">Hello, {name}!</h1>
    <p className="mt-1 text-blue-200">Welcome to your Study Space</p>
  </div>
);

// ClassroomCard Component

const ClassroomCard = ({ subject, icon, color, href }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        navigate(href);
      }}
    >
      <div
        className={`${color} text-white p-4 rounded-xl flex flex-col items-center justify-center text-center shadow-md hover:scale-105 transition-transform duration-200 cursor-pointer`}
      >
    <div className="text-3xl sm:text-4xl mb-2">{icon}</div>
    <span className="font-semibold text-sm sm:text-base">{subject}</span>
  </div>
  </button>

)};

// AI Companion Component
const AiCompanion = () => {
  const [input, setInput] = useState("");
  const handleSend = (e) => e.preventDefault();

  return (
    <Card className="flex flex-col h-full w-full">
      <div className="flex items-center gap-3 mb-4">
        <PiChatsCircle size={24} className="text-blue-600" />
        <div>
          <h3 className="font-bold text-gray-800">Personal AI Companion</h3>
          <p className="text-xs text-gray-500">
            Your friendly teaching companion ✨
          </p>
        </div>
      </div>
      <div className="flex-grow bg-gray-50 p-3 rounded-lg overflow-y-auto min-h-[150px]">
        <div className="text-sm text-gray-700">
          <p className="font-semibold text-blue-700">Welcome</p>
          <p>Hello, Smith! My name is PST AI. How can I assist you today?</p>
          <p className="text-xs text-gray-400 mt-1">14:49</p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask me anything..."
          className="flex-grow p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
        />
        <button
          onClick={handleSend}
          className="bg-blue-700 text-white p-3 rounded-lg hover:bg-blue-800 transition-colors flex-shrink-0"
        >
          <FaPaperPlane />
        </button>
      </div>
    </Card>
  );
};

// MoodTracker Component
const MoodTracker = () => {
  const [selectedMood, setSelectedMood] = useState(null);

  return (
    <Card>
      <h3 className="font-bold text-gray-800 mb-4">
        How are you feeling today?
      </h3>
      {/* Using flex-wrap to ensure buttons wrap on small screens */}
      <div className="flex justify-around flex-wrap mb-4 gap-2">
        {moodOptions.map((mood) => (
          <button
            key={mood.label}
            onClick={() => setSelectedMood(mood.label)}
            className={`flex flex-col items-center gap-2 p-2 rounded-lg w-16 transition-all ${
              selectedMood === mood.label
                ? "bg-blue-100 text-blue-600"
                : "text-gray-500 hover:bg-gray-100"
            }`}
          >
            {mood.icon}
            <span className="text-xs font-medium">{mood.label}</span>
          </button>
        ))}
      </div>
      <textarea
        placeholder="Add a note (optional)"
        className="w-full p-2 border rounded-lg text-sm h-16 resize-none focus:ring-2 focus:ring-blue-500 focus:outline-none"
      ></textarea>
      <button className="w-full mt-3 bg-blue-700 text-white font-semibold py-2 rounded-lg hover:bg-blue-800 transition-colors">
        Save
      </button>
    </Card>
  );
};

// WorkDue Component
const WorkDue = ({ itemsPending = 0 }) => (
  <Card className="text-center flex flex-col items-center justify-center h-full">
    <PiBookOpenTextBold size={40} className="text-gray-300 mb-4" />
    <h3 className="font-bold text-gray-800">Work Due</h3>
    <p className="text-sm text-gray-500 mt-2">{itemsPending} items pending</p>
    {itemsPending === 0 && (
      <p className="text-sm text-gray-400 mt-1">No work due at the moment!</p>
    )}
  </Card>
);

// XP Tracker Component
const XpTracker = ({ totalXp, currentLevel, levelName, xpForNextLevel }) => {
  const progress = (totalXp / xpForNextLevel) * 100;
  const xpToLevelUp = xpForNextLevel - totalXp;

  return (
    <Card>
      {/* Responsive flex container: stacks vertically on mobile, horizontally on medium screens and up */}
      <div className="flex flex-col md:flex-row gap-6 items-center">
        <div className="w-40 h-32 flex-shrink-0">
          <img
            src= {Treasure}
            alt=""
            className="w-full h-full object-contain"
          />
        </div>
        <div className="w-full">
          <div className="flex justify-between items-baseline mb-1">
            <h3 className="font-bold text-gray-800">Total XP</h3>
            <span className="font-bold text-lg text-yellow-500">{totalXp}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2">
            <div
              className="bg-yellow-400 h-2.5 rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-right text-xs text-gray-500">
            {xpToLevelUp} XP to Level {currentLevel + 1}
          </p>

          <div className="mt-3 text-center md:text-left">
            <p className="text-sm text-gray-500">Current Level</p>
            <p className="font-bold text-xl text-blue-600">
              Level {currentLevel}: {levelName}
            </p>
          </div>
        </div>
      </div>
      <p className="text-xs text-gray-400 text-center mt-4">
        Complete assignments and earn XP to unlock rewards in the Treasure
        Chest!
      </p>
    </Card>
  );
};

// Main Dashboard Page Component - This assembles the entire responsive layout
export default function Student() {
  return (
    <div>
     <Navbar/>
      <div className="bg-white min-h-screen p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          <Header name={userData.name} />

          <div className="mt-6">
            <h2 className="text-xl font-bold text-gray-700 mb-4">
              My Classrooms
            </h2>
            {/* Responsive grid for classrooms */}
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
              {classrooms.map((cls) => (
                <ClassroomCard
                  key={cls.name}
                  subject={cls.name}
                  icon={cls.icon}
                  color={cls.color}
                  href={cls.href}
                />
              ))}
            </div>
          </div>

          {/* Responsive main content grid: 1 column on mobile, 2 on large screens */}
          <main className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Left section: AI Companion takes full height */}
            <div className="flex">
              <AiCompanion className="w-full" />
            </div>

            {/* Right section: Three cards stacked vertically */}
            <div className="flex flex-col gap-6">
              <MoodTracker />
              <WorkDue itemsPending={0} />
              <XpTracker {...userData} />
            </div>
          </main>
        </div>
      </div>
     
    </div>
  );
}